import { createFileRoute, Link } from "@tanstack/react-router";
import { CityPageBody } from "@/components/site/CityPageBody";
import { BUSINESS } from "@/components/site/constants";
import { canonical } from "@/components/site/site-config";

export const Route = createFileRoute("/roofing-company-hernando-fl")({
  head: () => ({
    meta: [
      { title: "Roofing Company in Hernando, FL | Destination Roofing" },
      { name: "description", content: `Local roofing company serving Hernando, FL. Roof repair, replacement, metal and shingle roofing. Free Roof Inspection & Estimate. Call ${BUSINESS.phone}.` },
      { property: "og:title", content: "Roofing Company in Hernando, FL" },
      { property: "og:description", content: "Family-owned roofer serving Hernando, FL. Free Roof Inspection & Estimate." },
      { property: "og:url", content: canonical("/roofing-company-hernando-fl") },
    ],
    links: [{ rel: "canonical", href: canonical("/roofing-company-hernando-fl") }],
  }),
  component: () => (
    <CityPageBody
      city="Hernando"
      intro={
        <p>
          Hernando sits along the shore of Tsala Apopka Lake and includes a lot of established single-family neighborhoods. Homes here range from 70s and 80s block construction to newer builds, and many have asphalt shingle roofs that are now due for repair or replacement after years of Florida sun and storm exposure.
        </p>
      }
      localNotes={
        <>
          <p>
            Lakeside and heavy tree cover in Hernando often means more debris on roofs, clogged valleys, and moss on shaded slopes. We regularly find lifted shingles from summer storms and pipe-boot leaks on older homes.
          </p>
          <p>
            If your Hernando roof is 15+ years old, has visible granule loss, or you've seen ceiling stains after heavy rain, get it looked at before the next storm season.
          </p>
        </>
      }
      recentProjectSection={
        <section className="mx-auto max-w-4xl px-4 py-8">
          <h2 className="font-display text-2xl font-bold">Recent Roofing Work in Hernando, FL</h2>
          <p className="mt-3 text-muted-foreground">
            See a completed Galvalume metal roof we installed on a residential home in Hernando on the{" "}
            <Link to="/projects/galvalume-metal-roof-hernando-fl" className="text-brand underline">Hernando metal roof project page</Link>, or browse all{" "}
            <Link to="/projects" className="text-brand underline">roofing projects</Link>.
          </p>
        </section>
      }
    />
  ),
});
